import Marketing from "services/Marketing";
import {
    ELOQUA_LEAD_SOURCE_VALUES,
    ELOQUA_ABANDONED_CART_STATUS
} from "common/constants/Constants";
import get from "lodash.get";
import loginRegister from "ducks/loginRegister";

import {
    validateEmail,
    validateEmailsMatch,
    validateBloombergEmail
} from "common/utils/Validation";

const SET_IS_OPTED_IN = "SET_IS_OPTED_IN";

const defaultState = {
    isOptedIn: false
};

export function marketingReducer(state = defaultState, action = {}) {
    switch (action.type) {
        case SET_IS_OPTED_IN:
            return {
                ...state,
                isOptedIn: action.isOptedIn
            };
        default:
            return state;
    }
}

export function setIsOptedIn(isOptedIn) {
    return {
        type: SET_IS_OPTED_IN,
        isOptedIn
    };
}

export function sendEmailToEloquaAndCpref(email, leadSource, setStatusUnverified) {
    return (dispatch, getState) => {
        const {
            country,
            marketing: {
                isOptedIn
            }
        } = getState();

        if (!email) {
            console.error("Not sending to Eloqua - email is undefined.");

            return Promise.resolve();
        }

        if (isOptedIn || country === "US") {
            return Marketing.sendEmailToEloquaAndCpref(email, leadSource, setStatusUnverified);
        }

        return Promise.resolve();
    };
}

export function sendEmailToEloquaAndCprefSubscriptionFlow() {
    return (dispatch, getState) => {
        const state = getState();
        const {
            loginRegister: {
                email,
                confirmationEmail
            } = {}
        } = state;

        const error = validateBloombergEmail(email) || validateEmail(email) || validateEmailsMatch(email, confirmationEmail);

        if (error) {
            return Promise.resolve();
        }

        const leadSource = determineLeadSource(state);

        return dispatch(sendEmailToEloquaAndCpref(email, leadSource, true))
            .then(() => dispatch(updateAbandonedCartStatus(email, ELOQUA_ABANDONED_CART_STATUS.SUBSCRIBE_STARTED)));
    };
}

export function updateAbandonedCartStatus(email, abandonedCartStatus) {
    return (dispatch, getState) => {
        const {
            subscriptionForm: {
                selectedProductDetails:{
                    ratePlanId
                } = {},
                promoCodeInfo: {
                    promoCode
                } = {}
            } = {},
            counterOffers: {
                selectedOffer = {},
                offers = []
            } = {}
        } = getState();

        if (!email) {
            console.error("Not sending to Eloqua - email is undefined.");

            return Promise.resolve();
        }

        if (offers.length !== 0) {
            const counterOfferRatePlanIds = offers.map(({ ratePlanId: offerRatePlanId } = {}) => offerRatePlanId);

            return Marketing.updateAbandonedCartStatus({
                email,
                abandonedCartStatus,
                selectedRatePlanId: selectedOffer.ratePlanId,
                counterOfferRatePlanIds
            });
        }

        return Marketing.updateAbandonedCartStatus({ email, abandonedCartStatus, selectedRatePlanId: ratePlanId, promoCode });
    };
}

export function sendOptOutToCpref() {
    return (dispatch, getState) => {
        const {
            loginRegister: {
                email
            } = {},
            marketing: {
                isOptedIn
            }
        } = getState();

        if (!dispatch(loginRegister.validateSubscriptionEmails())) {
            return;
        }

        return Marketing.sendOptOutToCpref(email, isOptedIn);
    };
}

function determineLeadSource(state) {
    if (get(state, "bulkSubscriptionForm.ratePlan.offerType") === "GROUP") {
        return ELOQUA_LEAD_SOURCE_VALUES.GROUP;
    }

    if (get(state, "subscriptionForm.selectedProductDetails.offerType") === "STUDENT") {
        return ELOQUA_LEAD_SOURCE_VALUES.STUDENT;
    }

    if (get(state, "subscriptionForm.selectedProductDetails.productType") === "ALL") {
        return ELOQUA_LEAD_SOURCE_VALUES.ALL_ACCESS;
    }

    if (get(state, "subscriptionForm.selectedProductDetails.productType") === "DIGITAL") {
        return ELOQUA_LEAD_SOURCE_VALUES.DIGITAL;
    }

    return ELOQUA_LEAD_SOURCE_VALUES.UNKNOWN;
}

export default {
    marketingReducer,
    setIsOptedIn,
    sendEmailToEloquaAndCpref,
    sendEmailToEloquaAndCprefSubscriptionFlow,
    sendOptOutToCpref,
    updateAbandonedCartStatus
};
